import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserRole } from '@klubovna/api-client';
import { AuthService } from '../services';
import { UserFacade } from '../store/user/user.facade';
import { homeRouteForRole } from '../utils/home-route.util';

export const guestGuard: CanActivateFn = (route) => {
  const platformId = inject(PLATFORM_ID);
  const router = inject(Router);
  const userFacade = inject(UserFacade);
  const authService = inject(AuthService);

  if (!isPlatformBrowser(platformId)) {
    return true;
  }

  const user = userFacade.user() || authService.getUserFromStorage();
  const returnUrl = route.queryParamMap.get('returnUrl');

  if (!user) {
    return true;
  }

  if (returnUrl) {
    const isAdminRoute = returnUrl.startsWith('/admin');
    const isVolunteerRoute = returnUrl.startsWith('/volunteer');
    const isPosRoute = returnUrl.startsWith('/pos');

    if (
      (isPosRoute && [ UserRole.Owner, UserRole.Admin, UserRole.Cashier ].includes(user.role)) ||
      (isAdminRoute && [ UserRole.Owner, UserRole.Admin, UserRole.EventAdmin ].includes(user.role)) ||
      (isVolunteerRoute && user.role === UserRole.Volunteer)
    ) {
      return router.parseUrl(returnUrl);
    }
  }

  return router.createUrlTree([ homeRouteForRole(user.role, user.additionalRoles) ]);
};
